var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.storageLimitExceeded || _vm.flags.fileDownloadsDisabled
    ? _c("div", { staticClass: "cog-signature" }, [
        _c("p", { staticClass: "cog-signature__not-available-msg" }, [
          _c("em", [_vm._v("Signature not available.")]),
          _vm._v(" "),
          _vm.flags.fileDownloadsDisabled
            ? _c(
                "a",
                {
                  attrs: { href: "" },
                  on: { click: _vm.upgradeStorageLimits }
                },
                [_vm._v("Upgrade")]
              )
            : _vm._e()
        ])
      ])
    : _c(
        "div",
        {
          staticClass: "cog-input cog-signature",
          class: {
            "is-read-only": _vm.readonly,
            "cog-signature--keyboard": _vm.keyboardInput,
            "cog-signature--draw": !_vm.keyboardInput
          }
        },
        [
          _c(
            "div",
            {
              ref: "padContainer",
              staticClass: "cog-signature__pad",
              class: { "is-loading": _vm.showSpinner }
            },
            [
              _c("div", { staticClass: "cog-field__placeholder" }, [
                _c(
                  "div",
                  { staticClass: "cog-field__placeholder-inner" },
                  [_vm._v("\n\t\t\t\t \n\t\t\t\t"), _c("i-cog")],
                  1
                )
              ]),
              _vm._v(" "),
              _c("img", {
                ref: "canvasResizePng",
                staticClass: "canvas-png cog-offscreen",
                attrs: { src: _vm.signatureData },
                on: { load: _vm.signatureImageLoaded }
              }),
              _vm._v(" "),
              _c(
                "div",
                {
                  ref: "signaturePad",
                  staticClass: "cog-signature__canvas-container",
                  attrs: { tabindex: "-1" }
                },
                [_c("canvas", { ref: "signaturePadCanvas" })]
              ),
              _vm._v(" "),
              _vm.loadFont
                ? _c("link", {
                    attrs: {
                      href: `https://fonts.googleapis.com/css?family=${_vm.font.replace(
                        / /g,
                        "+"
                      )}&display=swap`,
                      rel: "stylesheet"
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("canvas", {
                ref: "textSignatureCanvas",
                staticClass: "cog-signature__text-canvas"
              }),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.keyboardInput,
                    expression: "keyboardInput"
                  },
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.textSignature,
                    expression: "textSignature"
                  }
                ],
                ref: "keyboardInput",
                staticClass: "cog-signature__keyboard-input",
                style: `font-size: ${_vm.fontSize}px; font-family: '${
                  _vm.font
                }', ${_vm.fontFallbacks}; color: ${
                  _vm.readonly ? "inherit" : _vm.signaturePadOptions.penColor
                };`,
                attrs: {
                  id: _vm.id ? "cog-" + _vm.id : null,
                  disabled: _vm.readonly || _vm.isLoading,
                  tabindex: !_vm.keyboardInput ? -1 : false,
                  type: "text",
                  spellcheck: "false",
                  autocomplete: "off"
                },
                domProps: { value: _vm.textSignature },
                on: {
                  blur: _vm.handleBlur,
                  focus: _vm.handleFocus,
                  input: [
                    function($event) {
                      if ($event.target.composing) return
                      _vm.textSignature = $event.target.value
                    },
                    _vm.handleInput
                  ],
                  change: _vm.handleChange
                }
              }),
              _vm._v(" "),
              !_vm.readonly && !_vm.isLoading
                ? _c(
                    "div",
                    { staticClass: "cog-signature__symbol" },
                    [
                      (_vm.hasMark && !_vm.keyboardInput) ||
                      (_vm.textSignature.length && _vm.keyboardInput)
                        ? _c(
                            "c-button",
                            {
                              ref: "remove",
                              staticClass: "cog-button--remove",
                              attrs: {
                                title: _vm
                                  .$resource("remove-item")
                                  .replace(
                                    "{item}",
                                    _vm.$parent.$source
                                      ? _vm.$parent.$source.label
                                      : ""
                                  ),
                                "no-style": ""
                              },
                              nativeOn: {
                                click: function($event) {
                                  return _vm.clear.apply(null, arguments)
                                }
                              }
                            },
                            [_c("i-ex")],
                            1
                          )
                        : _c(
                            "span",
                            {
                              staticClass: "cog-signature__write-symbol",
                              attrs: { "aria-hidden": "true" }
                            },
                            [_vm._v("×")]
                          )
                    ],
                    1
                  )
                : _vm._e()
            ]
          ),
          _vm._v(" "),
          !_vm.readonly && !_vm.isLoading
            ? _c(
                "div",
                { staticClass: "cog-signature__toggle-buttons" },
                [
                  _c("span", {
                    ref: "focusPlaceholder",
                    staticClass: "cog-offscreen",
                    attrs: { tabindex: _vm.focusPlaceholderActive ? 0 : -1 },
                    on: {
                      blur: function($event) {
                        _vm.focusPlaceholderActive = false
                      }
                    }
                  }),
                  _vm._v(" "),
                  _vm.isAllowed("draw")
                    ? _c(
                        "c-button",
                        {
                          attrs: {
                            "aria-labelledby": _vm.id
                              ? `cog-${_vm.id}-label`
                              : null,
                            "aria-describedby": _vm.id
                              ? `cog-${_vm.id}-draw-description`
                              : null,
                            "aria-controls": _vm.id ? "cog-" + _vm.id : null,
                            tabindex: !_vm.keyboardInput ? "-1" : false,
                            "no-style": "",
                            disabled: !_vm.keyboardInput
                          },
                          on: { click: _vm.activateDraw }
                        },
                        [
                          _vm._v(
                            "\n\t\t\t" +
                              _vm._s(_vm.$resource("signature-draw")) +
                              "\n\t\t\t"
                          ),
                          _c(
                            "span",
                            {
                              staticClass: "cog-offscreen",
                              attrs: { id: `cog-${_vm.id}-draw-description` }
                            },
                            [
                              _vm._v(
                                "\n\t\t\t\t(" +
                                  _vm._s(
                                    _vm.$resource("switch-to-drawing-mode")
                                  ) +
                                  ")\n\t\t\t"
                              )
                            ]
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isAllowed("type")
                    ? _c(
                        "c-button",
                        {
                          attrs: {
                            "aria-labelledby": _vm.id
                              ? `cog-${_vm.id}-label`
                              : null,
                            "aria-describedby": _vm.id
                              ? `cog-${_vm.id}-type-description`
                              : null,
                            "aria-controls": _vm.id ? "cog-" + _vm.id : null,
                            tabindex: _vm.keyboardInput ? "-1" : false,
                            "no-style": "",
                            disabled: _vm.keyboardInput
                          },
                          on: { click: _vm.activateKeyboard }
                        },
                        [
                          _vm._v(
                            "\n\t\t\t" +
                              _vm._s(_vm.$resource("signature-type")) +
                              "\n\t\t\t"
                          ),
                          _c(
                            "span",
                            {
                              staticClass: "cog-offscreen",
                              attrs: { id: `cog-${_vm.id}-type-description` }
                            },
                            [
                              _vm._v(
                                "\n\t\t\t\t(" +
                                  _vm._s(
                                    _vm.$resource("switch-to-typing-mode")
                                  ) +
                                  ")\n\t\t\t"
                              )
                            ]
                          )
                        ]
                      )
                    : _vm._e()
                ],
                1
              )
            : _vm._e()
        ]
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }